import { defineMessages } from 'react-intl';

export const supplierFilterMessages = defineMessages({
  selectSupplier: {
    id: 'CYVr3h',
    defaultMessage: 'Select Supplier',
    description: 'Label for supplier filter dropdown',
  },
  searchSuppliers: {
    id: 'aQcdOq',
    defaultMessage: 'Search suppliers...',
    description: 'Placeholder for supplier filter search input',
  },
});
